module.exports = __webpack_public_path__ + "img/upload.55fc2581.png";